import React from "react";
import { sharedStyles } from "./cardStyles";
import { Box, Card } from "@mui/material";

import {
  FlightCardDesktopDetailsAccordion,
  FlightItinerarySummary,
  IFlightCardTranslations,
  IFlightResult,
  IItinerary,
  MediaQuery,
  useConfig,
} from "@thekilroygroup/shared-ui";
import { getAirlineNames, getAirportName } from "utils/flightDetailApiUtils";
import { IAppConfigObject } from "../../appConfig.interfaces";
import { useTranslations } from "../../hooks/useTranslations";

interface IProps {
  children: any;
  itinerary: IItinerary;
  flightCardTranslations: IFlightCardTranslations;
}
export const TravelDetailsCard = (props: IProps) => {
  const { children, itinerary, flightCardTranslations } = props;
  const {
    translations: { flightSummary },
  } = useTranslations();
  const {
    locale,
    appConfig: { SHARED_ASSETS_BASE_URL },
  } = useConfig<IAppConfigObject>();

  return (
    <>
      <MediaQuery max="md">
        <Card sx={{ ...sharedStyles.card, mt: 2, pb: 2 }}>
          <Box
            sx={{
              pt: 0,
              pb: -2,
              px: 0,
            }}
          >
            {children}
          </Box>
          <FlightItinerarySummary
            {...flightCardTranslations}
            itinerary={props.itinerary}
            airlineLogosPath={`${SHARED_ASSETS_BASE_URL}/airline-logos`}
            getAirportName={getAirportName}
            title={flightSummary.details}
            locale={locale}
            defaultExpanded={false}
            getAirlineNames={getAirlineNames}
            flightItinerarySummaryTranslations={flightSummary}
            detailsAccordion={true}
          />
        </Card>
      </MediaQuery>
      <MediaQuery min="md">
        {children}
        <Card sx={{ ...sharedStyles.card, mt: 2, pb: 2 }}>
          {itinerary.flights.map((flight: IFlightResult, index: number) => {
            return (
              <Box key={`flight-details-desktop-${index}`}>
                <FlightCardDesktopDetailsAccordion
                  {...props}
                  sx={{ gap: 2 }}
                  {...flightCardTranslations}
                  flight={flight}
                  index={index}
                  defaultExpanded
                  getAirportName={getAirportName}
                  getAirlineNames={getAirlineNames}
                  passengerTypesTranslations={
                    flightCardTranslations.baggageInfoTranslations
                      .passengerTypes
                  }
                  itinerary={itinerary}
                  baggageTypesTranslations={
                    flightCardTranslations.baggageInfoTranslations.baggageTypes
                  }
                  locale={locale}
                />
              </Box>
            );
          })}
        </Card>
      </MediaQuery>
    </>
  );
};
